export const DIRS_PREFIX = '@DIRS';
